export default __webpack_public_path__ + "media/pro/enter-87ba0cc9.svg";